export function getURIWithoutHash(uri) {
  if (!uri) {
    return '';
  }
  return uri.split('#')[0];
}